module.exports = __webpack_public_path__ + "static/media/Hero.38507d6d.svg";